module.exports = __webpack_public_path__ + "img/marmelaedchen-einfahrt_xs.51d387a7.jpg";